import { UPDATE_MARKETING_DATA } from "app/actionTypes";

export const updateMarketingData = data => {
	return {
		type: UPDATE_MARKETING_DATA,
		data,
	};
};
